export const changePassword = {
    title: 'パスワードを変更',
    oldPasswordLabel: '以前のパスワード',
    newPasswordLabel: '新しいパスワード',
    confirmPasswordLabel: '新しいパスワードを再入力',
    password: 'パスワード',
    save: '変更を保存',
    cancel: 'キャンセル',
};
